
class CartHelper {
    constructor() {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }


    open(){
        this.cart.open();
    }
    close(){
        this.cart.close();
    }

    addItemToCart(variants){


        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();


        if (variants.length>1){
            for (var i = 0; i < variants.length; i++) {
                formData.append('items['+i+'][id]' , variants[i].id);
                formData.append('items['+i+'][size]' , variants[i].size);
                formData.append('items['+i+'][quantity]' , variants[i].quantity);
                if (variants[i].sales != undefined && variants[i].sales == true){
                    formData.append('properties[sale]' , true);
                }
            }
        }else{
            formData.append('Size' , variants[0].size);
            formData.append('id' , variants[0].id);
            formData.append('quantity' , variants[0].quantity);
            if (variants[0].sales != undefined && variants[0].sales == true){
                formData.append('properties[sale]' , true);
            }
        }



        // formData.append('quantity', 1);
        formData.append('form_type', 'product');
        // formData.append('id', variantId);
        // formData.append('items', variants);
        if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        return fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }
                this.error = false;
                this.cart.renderContents(response);
            })
            .catch((e) => {
                console.error(e);
            });
        // .finally(() => {
        //     // this.submitButton.classList.remove('loading');
        //     // if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        //     // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        //     // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        // });

    }






    updateCartItem(order, quantity){


        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();


        if (this.cart) {
            formData.append('line', order);
            formData.append('quantity', quantity);
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        return fetch(`${routes.cart_change_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }

                this.error = false;
                this.cart.renderContents(response);
            })
            .catch((e) => {
                console.error(e);
            });
        // .finally(() => {
        //     // this.submitButton.classList.remove('loading');
        //     // if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        //     // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        //     // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        // });

    }


    handleErrorMessage(errorMessage = false) {
        toastr.error(errorMessage);
        console.error(errorMessage);
        // this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        // if (!this.errorMessageWrapper) return;
        // this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        //
        // this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        //
        // if (errorMessage) {
        //     this.errorMessage.textContent = errorMessage;
        // }
    }
}
